import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: Number,
    duration: { type: Number, default: 2000 },
    suffix: { type: String, default: "" }
  }

  connect() {
    this.element.textContent = "0" + this.suffixValue

    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.animate()
        this.observer.disconnect()
      }
    }, { threshold: 0.5 })
    this.observer.observe(this.element)
  }

  animate() {
    const start = performance.now()
    const step = (now) => {
      const progress = Math.min((now - start) / this.durationValue, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      this.element.textContent = Math.floor(eased * this.targetValue) + this.suffixValue
      if (progress < 1) requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }
}
